import { ValidatorFn, FormGroup, ValidationErrors } from "@angular/forms";

export function frenchSelectValidator(control: FormGroup): ValidationErrors | null {
    const french = control.value.studyFrenchInSchool;
    const frenchStudyYears = control.value.frenchStudyYears;
    const frenchStudyHours = control.value.frenchStudyHours;
    const frenchTeacher = control.value.frenchTeacherName;

    return french && !(frenchStudyYears && frenchStudyHours && frenchTeacher) ? { "missingFrenchStudyInfo": true } : null;
}